import { apolloClient } from '~/apollo-client';
import { EnrollmentDataSource } from '~/typings/context';
import {
  EnrollmentOptionName,
  Flex_UpdateUtilityAccountMutation,
  Flex_UpdateUtilityAccountMutationVariables,
} from '~/typings/graphql';
import { UPDATE_UTILITY_ACCOUNT } from './update-utility-account.queries';

export interface UpdateUtilityAccountParams {
  addressSecondary?: string;
  billUploadIds?: number[];
  city?: string;
  estimatedAnnualKwh?: string | number;
  estimatedMonthlyKwh?: string | number;
  month?: string;
  state?: string;
  street?: string;
  utilityAccountId: number;
  utilityAccountNumber?: string;
  secondaryIdentifier?: string;
  zipCode?: string;
  enrollmentDataSourceName?: EnrollmentDataSource;
  nameKeyForEdi?: string;
}

export type UpdateUtilityAccountResponse = void;

export const updateUtilityAccount = async (
  params: UpdateUtilityAccountParams,
): Promise<UpdateUtilityAccountResponse> => {
  await apolloClient.mutate<
    Flex_UpdateUtilityAccountMutation,
    Flex_UpdateUtilityAccountMutationVariables
  >({
    mutation: UPDATE_UTILITY_ACCOUNT,
    variables: {
      id: params.utilityAccountId,
      input: {
        accountNumber: params.utilityAccountNumber,
        secondaryAccountIdentifier: params.secondaryIdentifier,
        ...(params.utilityAccountNumber && { status: 'active' }),
        annualizedUsageEstimate: params.estimatedAnnualKwh
          ? Math.round(Number(params.estimatedAnnualKwh))
          : undefined,
        estimatedMonthlyKwh: params.estimatedMonthlyKwh
          ? Math.round(Number(params.estimatedMonthlyKwh))
          : undefined,
        month: params.month ? params.month : undefined,
        serviceAddressCity: params.city,
        serviceAddressState: params.state,
        serviceAddressStreetOne: params.street,
        enrollmentDataSourceName: params.enrollmentDataSourceName as EnrollmentOptionName,
        serviceAddressStreetTwo: params.addressSecondary,
        serviceAddressZip: params.zipCode,
        nameKeyForEdi: params.nameKeyForEdi,
        billUploadIds: params.billUploadIds ?? [],
      },
    },
  });
};
